import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map, Set } from 'immutable';

import { ExportTemplateListItemEntity } from './export-template-list-item.entity';

export interface IExportTemplateListExtra
	extends IListColumnConfig<ExportTemplateListItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface IExportTemplateListEntity
	extends IListAttrs<ExportTemplateListItemEntity> {
	availableColumns: Map<string, IExportTemplateListExtra>;
}

const entityDefaults: IExportTemplateListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ExportTemplateListEntity
	implements
		IExportTemplateListEntity,
		IListOperations<ExportTemplateListEntity, ExportTemplateListItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IExportTemplateListExtra>
	): ExportTemplateListEntity {
		const inst = new ExportTemplateListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IExportTemplateListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ExportTemplateListItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, ExportTemplateListItemEntity>
	): ExportTemplateListEntity {
		return produce(this, (draft: ExportTemplateListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(): Set<string> {
		return this.elements.reduce((acc, exportItem) => {
			if (!exportItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...exportItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>());
	}

	public extractModifiers(): Set<string> {
		return this.elements.reduce((acc, exportItem) => {
			if (exportItem.updatedByAvatar && exportItem.updatedByAvatar?.name) {
				acc = acc.add(exportItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>());
	}

	public extractActionCreators(): Set<string> {
		return this.elements.reduce((acc, exportItem) => {
			if (exportItem.createdByAvatar && exportItem.createdByAvatar.name) {
				acc = acc.add(exportItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>());
	}
}
